import { Controller } from "@hotwired/stimulus"
import playerVolume from "../player_volume"

// Footer mute button and volume slider. Works without a player on the page;
// the preference is applied whenever one is ready.
export default class extends Controller {
  static targets = ["button", "slider"]

  initialize() {
    this.render = this.render.bind(this)
  }

  connect() {
    window.addEventListener("player:volume", this.render)
    this.render()
  }

  disconnect() {
    window.removeEventListener("player:volume", this.render)
  }

  toggleMute() {
    playerVolume.toggleMute()
  }

  change() {
    playerVolume.set(this.sliderTarget.valueAsNumber)
  }

  render() {
    // Like most players, the slider drops to zero while muted and returns to
    // the previous level on unmute.
    const level = playerVolume.muted ? 0 : playerVolume.level
    const silent = playerVolume.isSilent

    this.sliderTarget.value = level
    this.sliderTarget.style.setProperty("--volume", level)
    this.sliderTarget.setAttribute("aria-valuetext", `${level}%`)
    this.buttonTarget.dataset.muted = silent
    this.buttonTarget.setAttribute("aria-label", silent ? "Unmute" : "Mute")
  }
}
